import { Ptag } from "components/core";
import React from "react";
import GradeAttributeCard from "../GradeAttributeCard";
import {
  MaternityDeliveryDetailWrapper,
  MaternityDetailWrapper,
} from "./styles";
import AttributeInnerCard from "./AttributeInnerCard";

const MaternityDetail = ({ title, data }) => {
  return (
    <section>
      <Ptag fontSize="14px" marginBottom="20px">
        {title}
      </Ptag>
      <MaternityDetailWrapper>
        <GradeAttributeCard title="Delivery Coverage">
          <MaternityDeliveryDetailWrapper>
            {data?.delivery?.limit ? (
              <section>
                <AttributeInnerCard
                  title="Default"
                  value={data?.delivery?.limit}
                />
                {data?.delivery?.min && (
                  <AttributeInnerCard
                    title="Minimum Limit"
                    value={data?.delivery?.min}
                  />
                )}
                {data?.delivery?.max && (
                  <AttributeInnerCard
                    title="Maximum Limit"
                    value={data?.delivery?.max}
                  />
                )}
              </section>
            ) : (
              <>
                <div>
                  <Ptag fontWeight="600" marginBottom="8px">
                    Normal
                  </Ptag>
                  <AttributeInnerCard
                    title="Limit"
                    value={data?.delivery?.normal}
                  />
                </div>
                <div>
                  <Ptag fontWeight="600" marginBottom="8px">
                    C-Section
                  </Ptag>
                  <AttributeInnerCard
                    title="Limit"
                    value={data?.delivery?.cesarian}
                  />
                </div>
              </>
            )}
          </MaternityDeliveryDetailWrapper>
          {data?.delivery?.remarks && (
            <Ptag
              fontWeight="400"
              fontSize="12px"
              color="#4a4a4a"
              marginTop="14px"
            >
              Remarks: {data?.delivery?.remarks}
            </Ptag>
          )}
        </GradeAttributeCard>
        {data?.new_born && (data?.new_born?.limit || data?.new_born?.remarks) && (
          <GradeAttributeCard
            title="New Born Baby Cover"
            limit={data?.new_born?.limit}
            remarks={data?.new_born?.remarks}
          />
        )}
        {(data?.natal?.limit || data?.natal?.remarks) && <GradeAttributeCard
          title="Pre/Post Natal"
          limit={data?.natal?.limit}
          remarks={data?.natal?.remarks}
        />}
      </MaternityDetailWrapper>
    </section>
  );
};

function AttributeMaternity({ data }) {
  if (data?.type === "METRO_NON_METRO") {
    return (
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "46px",
        }}
      >
        <MaternityDetail title="Metro Cities" data={data?.values?.metro} />
        <MaternityDetail
          title="Non-Metro Cities"
          data={data?.values?.non_metro}
        />
      </section>
    );
  }
  if (data?.type === "DEFAULT") {
    return (
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "46px",
        }}
      >
        <MaternityDetail data={data?.values} />
      </section>
    );
  }
  return null;
}

export default AttributeMaternity;
